'use client';

import { useToastStore } from '@/store';
import { Toast } from 'primereact/toast';
import { useEffect, useRef } from 'react';
import styles from './toast.module.css';

const MyToast = () => {
	const toastRef = useRef<Toast | null>(null);
	const setToastRef = useToastStore((state) => state.setToastRef);
	const toastProps = useToastStore((state) => state.toastProps);

	useEffect(() => {
		setToastRef(toastRef);
	}, [setToastRef]);

	return (
		<Toast
			className={styles.toastContainer}
			ref={toastRef}
			{...toastProps}
		/>
	);
};

export default MyToast;
